import React, { useEffect } from 'react'
import RootStore from '../../../store/RootStore'
import Editor from './Editor'
import { observer } from 'mobx-react'
import { useRoute } from '@react-navigation/core'
import { paths } from '../../links'
import ApplicationStore from './ApplicationStore'
import Loading from '../../Loading'

export default observer(function Application() {
  const route = useRoute()
  const { loadApplication, loading } = ApplicationStore

  const { userStore } = RootStore
  const { document } = userStore

  useEffect(() => {
    const type =
      route.name === paths.CreditApplication
        ? 'loan_application'
        : 'supplier_application'
    loadApplication(type)
  }, [route.name, loadApplication])

  return loading ? <Loading /> : <Editor document={document} />
})
